const timeSlots = state => state.timeSlots || [];
const dates = state => {
  if (state.timeSlots) {
    return Object.keys(state.timeSlots).sort();
  }

  return []
};

export default {
  timeSlots,
  dates
}
